import Lock from '@mdi/svg/svg/lock.svg?react';
import { getLogoutURL } from '@solinkcorp/authentication';
import { Button, Flex, MDIIcon } from '@solinkcorp/solink-components';
import { useNavigate } from 'react-router-dom';
import 'src/styles/animate.sass';
import styles from './AccessRestricted.module.sass';

interface AccessRestrictedProps {
  message: string;
  redirectButtonText: string;
}

function AccessRestricted(props: AccessRestrictedProps) {
  const navigate = useNavigate();

  const visitLoginPage = () => {
    navigate(getLogoutURL('RESTRICTED_ACCESS'));
  };

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      height="100vh"
      className={styles.accessRestrictedWrapper}
    >
      <Flex
        alignItems="center"
        flexDirection="column"
        height="auto"
        width="500px"
        className={styles.accessRestrictedCard}
      >
        <img title="Solink logo" src="images/large-solink.png" width="200px" />
        <h2 className={styles.accessRestrictedMessage}>{props.message}</h2>
        <MDIIcon
          icon={Lock}
          fill="#878787"
          size={96}
          style={{ animation: 'shake', animationDuration: '1s' }}
        />
        <Button
          text={props.redirectButtonText}
          onClick={visitLoginPage}
          style={{ margin: '2em' }}
        />
      </Flex>
    </Flex>
  );
}

export default AccessRestricted;
